import React from "react";

import ResultCard from "../resultCard";

const LastSoldPlayer = ({ player }) => (
  <ResultCard label="Last sold player" player={player} />
);

export default LastSoldPlayer;
